module.exports = __webpack_public_path__ + "static/img/dafu.2e4b1c62.png";